import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';


@Component({
    selector: 'status-cell',
    standalone: true,
    imports: [CommonModule],
    template: `
    <span class="cell-text" [ngClass]="data === 'FW Pending' ? 'fw-pending-text' : ''">
      {{ data }}
</span>
  `,
    styles: [
        `
    .cell-text {
        font-family: var(--manrope);
        font-weight: 500;
        font-size: 16px;
        color: var(--text-secondary);
      }

      .fw-pending-text {
        color: var(--brand-destructive) !important;
      }
    `,
    ],
})
export class StatusCellComponent {
    @Input() data: any;
}
